export function isLegacyServiceAgentSession(session) {
    return (typeof session === "object" &&
        session !== null &&
        "userID" in session &&
        "lastUpdatedTime" in session);
}
/** Maps a legacy raw session to the canonical {@link AgentSession} shape (session-level fields only). */
export function fromLegacyServiceAgentSession(session) {
    return {
        id: session.id,
        userId: session.userID,
        lastUpdateTime: session.lastUpdatedTime
            ? new Date(session.lastUpdatedTime).getTime()
            : undefined,
        appName: session.appName
    };
}
//# sourceMappingURL=sessions.legacy.js.map